export default __webpack_public_path__ + "static/media/SWAST_CNS.3b317e6d.xml";